import { routeMeta } from './navigation'
import { ASPECT_ORDER } from './contracts/diagnosisReport'

// Jobs-first Vue Router setup for the M6 frontend rebuild.
//
// Primary IA:
//   Home -> Reports -> Practice -> Progress -> Account
//
// Old ritual URLs redirect intentionally so shared links do not dead-end.

// The report hub is master-detail: the overview lives at the report/analysis
// path, and each aspect drill-down is a real, deep-linkable subpath
// (`/report/chesscom/foo/strategy`). Constraining the optional param to the
// known aspects keeps unknown suffixes out of the report view (they fall to
// NotFound) while every real aspect gets its own URL and browser history entry.
const ASPECT_SUBPATH = `:aspect(${ASPECT_ORDER.join('|')})?`

export const routes = [
  { path: '/', redirect: '/home' },
  {
    path: '/home',
    component: () => import('./views/HomeDashboard.vue'),
    meta: routeMeta('home'),
  },
  {
    path: '/analysis',
    component: () => import('./views/AnalysisList.vue'),
    meta: routeMeta('analysis'),
  },
  {
    path: `/analysis/:analysisId/${ASPECT_SUBPATH}`,
    name: 'analysis-detail',
    component: () => import('./views/AnalysisDetail.vue'),
    meta: routeMeta('analysis'),
  },
  {
    path: '/practice',
    component: () => import('./views/PracticeList.vue'),
    meta: routeMeta('practice'),
  },
  {
    path: '/practice/:practiceId',
    component: () => import('./views/PracticeDetail.vue'),
    meta: routeMeta('practice'),
  },
  {
    path: '/progress',
    component: () => import('./views/ProgressView.vue'),
    meta: routeMeta('progress'),
  },

  {
    path: `/report/:platform/:username/${ASPECT_SUBPATH}`,
    name: 'report',
    component: () => import('./views/PublicReport.vue'),
    meta: routeMeta('report'),
  },
  {
    path: '/r/:platform/:username',
    redirect: (to) => ({
      path: `/report/${encodeURIComponent(String(to.params.platform))}/${encodeURIComponent(String(to.params.username))}`,
      query: to.query,
    }),
  },

  { path: '/coach', redirect: '/home' },
  { path: '/mission', redirect: '/practice' },
  { path: '/verdict/:pollSessionId', redirect: '/progress' },
  { path: '/weapon/:platform/:username', redirect: '/practice' },
  { path: '/vs', redirect: '/home' },
  { path: '/vs/:a/:b', redirect: '/home' },
  { path: '/otb', redirect: '/home' },

  { path: '/login', component: () => import('./views/Login.vue'), meta: routeMeta('login') },
  { path: '/auth/callback', component: () => import('./views/AuthCallback.vue'), meta: routeMeta('authCallback') },
  {
    path: '/account',
    component: () => import('./views/AccountSettings.vue'),
    meta: routeMeta('account'),
  },

  ...(import.meta.env.DEV
    ? [
        { path: '/gate0', component: () => import('./views/Gate0Evidence.vue'), meta: routeMeta('gate0') },
        { path: '/review', component: () => import('./views/ReviewWorkbench.vue'), meta: routeMeta('review') },
      ]
    : []),

  { path: '/:pathMatch(.*)*', component: () => import('./views/NotFound.vue'), meta: routeMeta('notFound') },
]
